import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useState } from 'react';
import LoadableObjContainer from "nood-comp/src/comp/ui/containers/LoadableObjContainer";
import * as stylex from '@stylexjs/stylex';
import EntityPropertyBox from "nood-comp/src/comp/ui/containers/EntityPropertyBox";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import DateTimeViewer from "nood-comp/src/comp/ui/date-viewer/DateTimeViewer";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import { NavLink } from "react-router-dom";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import Text from "nood-comp/src/comp/text/Text";
import { useHttpGet } from "nood-comp/src/hooks/useHttpGet";
import { getQueryParam } from "nood-comp/src/net/xhr";
export default function OrgUserView(props) {
  var _orguser$org;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    orguser = _useState2[0],
    set_orguser = _useState2[1];
  var id = getQueryParam('id');
  id && useHttpGet({
    path: "/orguser/".concat(id),
    setter: set_orguser
  });
  return /*#__PURE__*/React.createElement(LoadableObjContainer, {
    obj: orguser
  }, (orguser === null || orguser === void 0 ? void 0 : orguser.id) && /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.property_viewer_container ev78zum5 ev1qjc9v5 ev1qhigcl evpfjxx8 ev1xj6626 evh5ulna ev7c9az1 ev1mse8r3 ev1j4eaoi ev1xpd4zr"
  }, /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.prop_container ev78zum5 ev8nb7dd"
  }, /*#__PURE__*/React.createElement(EntityPropertyBox, {
    label: "Username",
    icon: "at-sign",
    value: orguser.username
  })), /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.prop_container ev78zum5 ev8nb7dd"
  }, /*#__PURE__*/React.createElement(EntityPropertyBox, {
    label: "Username",
    icon: "at-sign",
    value: orguser.username
  })), /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.prop_container ev78zum5 ev8nb7dd"
  }, /*#__PURE__*/React.createElement(EntityPropertyBox, {
    label: "Email Address",
    icon: "inbox",
    value: orguser.email
  })), /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.prop_container ev78zum5 ev8nb7dd"
  }, /*#__PURE__*/React.createElement(EntityPropertyBox, {
    label: "Created On",
    icon: "calendar",
    value: /*#__PURE__*/React.createElement(Flex, {
      gap: 5
    }, /*#__PURE__*/React.createElement(DateTimeViewer, {
      date: orguser.created_dt,
      view_format: "mmmm d, yyyy hh:MM tt"
    }), /*#__PURE__*/React.createElement(ElapsedTime, {
      datetime: orguser.created_dt
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.prop_container ev78zum5 ev8nb7dd"
  }, /*#__PURE__*/React.createElement(EntityPropertyBox, {
    label: "Last Login",
    icon: "calendar",
    value: /*#__PURE__*/React.createElement(Flex, {
      gap: 5
    }, orguser.last_login_dt ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateTimeViewer, {
      date: orguser.last_login_dt,
      view_format: "mmmm d, yyyy hh:MM tt"
    }), /*#__PURE__*/React.createElement(ElapsedTime, {
      datetime: orguser.last_login_dt
    })) : /*#__PURE__*/React.createElement(Text, {
      secondary: true
    }, "No data"))
  })), /*#__PURE__*/React.createElement("div", {
    className: "OrgUserView__ui.prop_container ev78zum5 ev8nb7dd"
  }, /*#__PURE__*/React.createElement(EntityPropertyBox, {
    icon: "square",
    label: "Organization",
    value: /*#__PURE__*/React.createElement(React.Fragment, null, (_orguser$org = orguser.org) === null || _orguser$org === void 0 ? void 0 : _orguser$org.display_name, " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(NavLink, {
      to: "/orgs?pg=orgs&do=view&id=".concat(orguser.org.id)
    }, /*#__PURE__*/React.createElement(Flex, {
      style: {
        color: "var(--shade-40)"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: "at-sign",
      size: 13
    })), /*#__PURE__*/React.createElement("div", null, orguser.org.username))))
  }))));
}

// @ts-ignore
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1oin6zd{margin:10px}", 1000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1qjc9v5{align-items:stretch}", 3000);
_inject(".ev1qhigcl{padding:20px}", 1000);
_inject("@media(min-width:501px){.evpfjxx8.evpfjxx8{gap:20px}}", 2200);
_inject("@media(min-width:501px){.ev1xj6626.ev1xj6626{flex-wrap:wrap}}", 3200);
_inject("@media(min-width:501px){.evh5ulna.evh5ulna{max-width:600px}}", 4200);
_inject("@media(min-width:501px){.ev7c9az1.ev7c9az1{margin-left:auto}}", 4200);
_inject("@media(min-width:501px){.ev1mse8r3.ev1mse8r3{margin-right:auto}}", 4200);
_inject("@media(max-width:500px){.ev1j4eaoi.ev1j4eaoi{flex-direction:column}}", 3200);
_inject("@media(max-width:500px){.ev1xpd4zr.ev1xpd4zr{gap:10px}}", 2200);
_inject("@media(min-width:501px){.ev8nb7dd.ev8nb7dd{flex:0 0 calc(50% - 10px)}}", 2200);